import { cn, PaletteUtils } from '@shared/utils';

interface MessageWrapperProps {
  className?: string;
  contentClassName?: string;
  children?: React.ReactNode;
  onClick?: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
}

export const MessageWrapper = (props: MessageWrapperProps) => {
  return (
    <div className={cn('mb-2', props.className)} onClick={props.onClick}>
      <div
        className={cn(
          'flex rounded-sm bg-white p-5 dark:bg-soft-black',
          PaletteUtils.isVcfcPalette && 'rounded-xl dark:border dark:border-gray-black',
          props.contentClassName,
        )}
      >
        {props.children}
      </div>
    </div>
  );
};
